import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import SectionFullH from 'src/components/sections/section-full-h';
// import { API_URI } from 'src/constants';
// import SectionEventNewspaper from 'src/components/sections/section-event/section-event-newspaper';
import _ from 'lodash';
import { useRouter } from 'next/router';
import { SHOW_COMMEMORATE } from 'src/constants';
import { KEY_ADS_PAGE, KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { isRender } from 'src/utils/device';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';

const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'), { ssr: false });

const SectionThree = ({ ads }) => {
  const [sectionThreeData, setSectionThreeData] = useState(null);
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        const response = await GET(
          `/api/v1.0/home/section-four${convertObjPath({
            block1: 4,
            block2: 4,
            block3: 4
          })}`
        );
        if (!_.isEmpty(response)) setSectionThreeData(response);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION_THREE ERROR :`, err.message);
      }
    })();
  }, []);

  return (
    <>
      <section id='section-8' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          <div className='col-lg-4'>
            {!_.isEmpty(sectionThreeData?.block1?.data) && (
              <SectionFullH
                data={sectionThreeData.block1}
                count={4}
                path={sectionThreeData.block1.link}
                heading={sectionThreeData.block1.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-8',
                  position: 'ใต้:section-7',
                  data: {
                    block: '1',
                    heading: sectionThreeData.block1.title
                  }
                }}
              />
            )}
          </div>

          <div className='col-lg-4'>
            {!_.isEmpty(sectionThreeData?.block2?.data) && (
              <SectionFullH
                data={sectionThreeData.block2}
                count={4}
                path={sectionThreeData.block2.link}
                heading={sectionThreeData.block2.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-8',
                  position: 'ใต้:section-7',
                  data: {
                    block: '2',
                    heading: sectionThreeData.block2.title
                  }
                }}
              />
            )}
          </div>

          <div className='col-lg-4'>
            {!_.isEmpty(sectionThreeData?.block3?.data) && (
              <SectionFullH
                data={sectionThreeData.block3}
                count={4}
                path={sectionThreeData.block3.link}
                heading={sectionThreeData.block3.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-8',
                  position: 'ใต้:section-7',
                  data: {
                    block: '3',
                    heading: sectionThreeData.block3.title
                  }
                }}
              />
            )}
          </div>
        </div>
      </section>

      {isRender('desktop') && <DynamicAds page={KEY_ADS_PAGE.HOMEPAGE} position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
      {/* <SectionEventNewspaper /> */}
    </>
  );
};

export default SectionThree;
